import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyListComponent } from './company-list.component';
import { GlobalModulesModule } from '../../global-modules/global-modules.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
  ],
  declarations: [CompanyListComponent],
  entryComponents: [CompanyListComponent],
  exports: [CompanyListComponent]
})
export class CompanyListModule { }